<!-- Ported from the Polaris kit: src/components/ui/skeleton/Skeleton.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div
    data-slot="skeleton"
    :class="
      cn('animate-pulse rounded-polaris-md bg-polaris-primary/10', props.class)
    "
  />
</template>
